import React from "react";
import { IMAGES } from "../../lib/content";
import { TrustPillars, LicenseCard } from "../about/TrustPillars";
import { ServiceArea } from "../ServiceArea";

export default function About({ t }) {
  return (
    <section id="about" data-testid="about-section" className="relative py-20 md:py-32 bg-brand-light">
      <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div data-testid="about-image-wrap" className="lg:col-span-5 relative">
            <div className="relative aspect-[4/5] overflow-hidden bg-brand-secondary">
              <img
                src={IMAGES.about}
                alt="Roofing underlayment being installed by our crew"
                className="absolute inset-0 w-full h-full object-cover"
                loading="lazy"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 md:-bottom-8 md:-right-8 bg-brand-accent text-white p-5 md:p-7 max-w-[220px] shadow-xl">
              <div className="font-display text-4xl md:text-5xl font-black leading-none">25</div>
              <div className="font-display text-xs md:text-sm font-bold tracking-widest uppercase mt-1.5">
                {t.trust.yearsBadge}
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 lg:pl-6">
            <span className="section-tag" data-testid="about-tag">{t.trust.tag}</span>
            <h2
              data-testid="about-title"
              className="font-display font-black text-brand-primary text-3xl sm:text-4xl lg:text-5xl tracking-tighter mt-5 leading-[1.05]"
            >
              {t.trust.title}
            </h2>
            <p data-testid="about-lead" className="mt-6 text-lg text-brand-secondary leading-relaxed font-body">
              {t.trust.lead}
            </p>
            <p className="mt-5 text-base text-brand-muted leading-relaxed font-body">{t.trust.p1}</p>
            <p className="mt-4 text-base text-brand-muted leading-relaxed font-body">{t.trust.p2}</p>
            <TrustPillars t={t} />
            <LicenseCard t={t} />
            <div className="mt-8">
              <ServiceArea t={t} theme="light" testId="about-service-area" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
